import { Component } from '@angular/core';
import { QuotesTableComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-quotes-table',
    templateUrl: './sjoborg-quotes-table.component.html',
    styleUrls: ['./sjoborg-quotes-table.component.css'],
    standalone: false
})
export class SjoborgQuotesTableComponent extends QuotesTableComponent {}
